import React from 'react';

const PasswordConfirmation = () => {
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>Password Changed</h2>
        <p style={styles.text}>
          Your password has been successfully changed.<br />
          You can now sign in with your new password.
        </p>
        <a href="/signin" style={styles.link}>
          Go to Sign In
        </a>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    background: '#f5f6fa',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  card: {
    background: '#fff',
    padding: '40px',
    borderRadius: '12px',
    boxShadow: '0 2px 16px rgba(0,0,0,0.12)',
    maxWidth: '400px',
    width: '100%',
    textAlign: 'center',
  },
  title: {
    color: '#4078c0',
    fontSize: '2rem',
    marginBottom: '18px',
  },
  text: {
    color: '#555',
    fontSize: '1.1rem',
    marginBottom: '24px',
  },
  link: {
    display: 'inline-block',
    marginTop: '18px',
    color: '#4078c0',
    textDecoration: 'underline',
    fontWeight: 'bold',
    fontSize: '1rem',
  },
};

export default PasswordConfirmation;